import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { GrClose } from 'react-icons/gr'
import { Footer } from '../../index'
import { FONT, LINK, LINKWICANDERS, LINKWISE } from '../../../assets/constants/constants'
import { SharedIcon } from '../../'
import { Title, Languages, MenuExpansive, MenuExpansiveTitle, MenuExpansiveMap } from '../../'

import {
  StyledDiv,
  StyledIcon,
  StyledMenuMain,
  StyledMenuHeader,
  StyledMenuFooter,
  StyledSharedIcons
} from './index.styled';
// import { useResize } from '../../../hooks';
import { setMenu, setMenuContent, updateLanguage, setCurrentStep, setCurrentCollection, setCurrentGama } from '../../../effects/actions'
// import MenuItemsComponent from '../../menu/items'
const languages = require('../../../assets/mock-data/languages.json')
const collections = require('../../../assets/mock-data/collections.json')

const MenuContainerComponent = ({
  showFactory = true, showSharedIcons = true, locale, updateLanguage, setMenuContent,
  currentSite, setMenu, setCurrentStep, setCurrentCollection, setCurrentGama, currentStep,
  isMap = false, currentMap, currentGama, currentCollection
}) => {
  // const isMobile = useResize().isMobile;
  const history = useHistory()
  const [showLanguages, setShowLanguages] = React.useState(false);
  const [language, setLanguage] = React.useState(false);
  const [showMenuCollection, setShowMenuCollection] = React.useState(false);

  const handleClose = () => {
    setMenu(false)
    setMenuContent(null)
  }

  React.useEffect(() => {
    const lang = languages.find(x => x.value === locale)
    setLanguage(lang)
  }, [locale])

  React.useEffect(() => {
    if(currentStep !== "gama" && showMenuCollection === false){
      setShowMenuCollection(true) 
    }else if(currentStep === "gama" && showMenuCollection === true) {
      setShowMenuCollection(false) 
    }
  }, [currentStep, showMenuCollection])

  

  const getLinks = () => {
    switch (currentSite) {
      case 'wicanders':
        return LINKWICANDERS
      case 'wise':
        return LINKWISE
      case 'factory':
        return LINK
      default:
        return {}
    }
  }
  
  const renderMenuLanguages = () => (
    <React.Fragment>
      <Title />
      <Languages
        selectedLanguage={language}
        updateShowLanguage={() => {
          setShowLanguages(false)
        }}
        updateSelectedLanguage={(language) => {
          updateLanguage(language)
        }}
      />
    </React.Fragment>
  )

  const renderMenuMain = () => (
    <MenuExpansive expandAll={false} currentSite={currentSite} onClickMenu={(item) => {
      switch (item.id) {
        case "contacts":
          window.open("https://www.amorimcorkflooring.com/contacts", "_blank")
          break;
        case "showroom":
          history.push('/splash-split')
          break;
        case "wise":
          setMenuContent(item.id)
          setShowMenuCollection(true)
          break;
  
        case "wicanders":
          setMenuContent(item.id)
          setShowMenuCollection(true)
          break;
        case "raw-material":
          history.push('/vr/outside/11')
          setMenu(false)
          break;
        default:
          setMenuContent(item.id)
          setShowMenuCollection(false)
          break;
      }
    }} />
  )

  const renderMenuCollection = () => (
    <MenuExpansiveTitle  
      currentSite={currentSite}
      currentGama={currentGama}
      currentCollection={currentCollection}
      onClickMenu={(item) => {
        setCurrentGama(item.slug)
      }} 
      onClickSubMenu={(item) => {
        let collection = collections.find(x => x.collection === item.id)
        setCurrentStep("collection")
        setCurrentCollection(collection)
      }}
      onBack={() => {
        if(currentStep === "collection"){
          setCurrentCollection(null)
          setCurrentStep("collections")
        }else if(currentStep === "collections"){
          setCurrentGama(null)
          setCurrentStep("gama")
          setShowMenuCollection(false)
        }else if(currentStep === "product"){
          setCurrentStep("products")
        }else if(currentStep === "products"){
          setCurrentStep("collection")
        }
       
      }}
    />
  )

  const renderMenuMap = () => (
    <MenuExpansiveMap expandAll={false} currentMap={currentMap} currentSite={currentSite}
      onClickMenu={(item) => {
          if(item.redirect !== undefined){
            history.push(item.redirect)
            handleClose()
          }else if(item.pano !== undefined){
            history.push(item.pano)
            handleClose()
          }
      }} 
    />
  )


  const renderMenu = () => {
    if(showLanguages === true){
      return renderMenuLanguages()
    }else if(showMenuCollection === true){
      return renderMenuCollection()
    }else if(isMap === true){
      return renderMenuMap()
    }else{
      return renderMenuMain()
    }
  }

  return (
    <StyledDiv>
      <StyledMenuHeader>
        <StyledIcon onClick={() => handleClose()}>
          <GrClose size={FONT.md} />
        </StyledIcon>
        {showSharedIcons &&
          <StyledSharedIcons>
            <SharedIcon links={getLinks()} />
          </StyledSharedIcons>
        }
      </StyledMenuHeader>
      <StyledMenuMain>
        {renderMenu()}
      </StyledMenuMain>
      <StyledMenuFooter>
        <Footer
          showLanguage={showLanguages}
          updateShowLanguage={setShowLanguages}
          language={locale}
        />
      </StyledMenuFooter>
    </StyledDiv>
  )
};


const mapStateToProps = ({ app }) => {
  const { locale, currentSite, currentStep, currentMap, currentGama, currentCollection } = app

  return {
    locale, currentSite, currentStep, currentMap, currentGama, currentCollection
  }
}

export default connect(mapStateToProps, {
  updateLanguage,
  setMenuContent,
  setMenu,
  setCurrentStep,
  setCurrentCollection,
  setCurrentGama
})(React.memo(MenuContainerComponent))
